import Modal from "react-modal";
import { ReactNode } from "react";
import { useApp } from "../providers";

import { ModalContext, ModalsType } from "./ModalContext";
import EditProfileModal from "components/modals/edit-profile";
import SelectWalletModal from "components/modals/selectWalletModal";


Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    background: "transparent",
    padding: 0,
    zIndex: 9999,
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    backdropFilter: "blur(4px)",
    zIndex: 9998,
  },
};

interface ModalProviderProps {
  children: ReactNode;
}

const ModalProvider = ({ children }: ModalProviderProps) => {
  const {
    modalStatus,
    setModalStatus,
    activeModal,
    setActiveModal,
    selectWalletModalState,
    setSelectWalletModalState
  } = useApp();

  const openModal = (modal: ModalsType = "edit-profile") => {
    setActiveModal(modal);
    setModalStatus(true);
  };

  const closeModal = () => {
    setModalStatus(false);
  };

  const openSelectWalletModal = () => {
    setSelectWalletModalState(true);
  };

  const closeSelectWalletModal = () => {
    setSelectWalletModalState(false);
  };

  return (
    <ModalContext.Provider
      value={{
        activeModal,
        openModal,
        closeModal,
        selectWalletModalState,
        setSelectWalletModalState,
        openSelectWalletModal,
        closeSelectWalletModal,
      }}
    >
      <Modal
        style={customStyles}
        isOpen={modalStatus}
        onRequestClose={closeModal}
        bodyOpenClassName={"modal-open"}
      >
        {activeModal === "edit-profile" ? (
          <EditProfileModal />
        ) : null}
      </Modal>

      <Modal
        style={customStyles}
        isOpen={selectWalletModalState}
        onRequestClose={closeSelectWalletModal}
        bodyOpenClassName={"modal-open"}
        ariaHideApp={false}
      >
        <SelectWalletModal />
      </Modal>

      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
